import ReactModal from "react-modal";
import styled from "styled-components";

export const Container = styled.form`
  position: relative;
  background: white;
  border-radius: 2rem;
  
  h1 {
    font-weight: 600;
  }

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
  }

  button {
    height: 4rem;
    width: 25rem;
    font-size: 1.5rem;
    border-radius: 0.5rem;
  }

  .close-button {
    position: absolute;
    top: 2rem;
    right: 2rem;
    cursor: pointer;
    z-index: 10;
  }

  .model-container {
    padding: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center; 
  }

  .popup-title {
    text-align: center;
  }

  .add-button {
    /* margin: 1rem 0; */
  }
`;

export const StyledReactModal = styled(ReactModal)`
  /* The modal content styling is now handled via inline styles in the component */
  /* This allows for better control over overlay and content positioning */
  
  &:focus {
    outline: none;
  }
`;